<div class="box green_box"></div>
<div class="box pink_box"></div>
<div class="blur_ball">
  <img src="assets/images/small.svg" class="top1" alt="" />
  <img src="assets/images/small.svg" class="bottom1" alt="" />
</div>

<main class="main_signin">

  <div *ngIf="isForgotPassword" >
    <form [formGroup]="form" (ngSubmit)="forgotPassword()"  class="form">
      <div class="forgot_password"  >
        <h2 class="title">Forgot Password</h2>
        <div class="contain">
          <div class="the_input">
            <label for="">Email</label>
            <input type="email" formControlName="username" class="default_input" placeholder="Enter Email"/>
            <div *ngIf="forgotsubmitted && forgotpass.username.errors" >
              <div *ngIf="forgotpass.username.errors.required" style="color: red; padding-top: 3px;">Email is required</div>
              <div *ngIf="forgotpass.username.errors.email" style="color: red; padding-top: 3px;">Email must be a valid email address</div>
          </div>
          </div>
          <span style="color: red">An Email will be sent to you after submission, check your mail to continue.</span>
          
        </div>
    
        <div class="submit">
          <button type="submit" class="default_primary-button"  [ngClass]="{ 'inactive_btn': (gatewayService.isLoading$ | async) }" [disabled]="(gatewayService.isLoading$ | async)" >Submit</button>
        
          <div *ngIf="(gatewayService.isLoading$ | async)">
            <mat-progress-spinner mode="indeterminate" diameter='30' strokeWidth='1' ></mat-progress-spinner>
          </div>
        </div>
      </div>
  
    
      </form>
  </div>

  <div *ngIf="!isForgotPassword && (tokenIsExpire || !tokenIsValid)" >
       
    <div style="color: red; font-size: 16px;">
      Invalid link, please check your mail
    </div>

  </div>

  <div *ngIf="!isForgotPassword && !tokenIsExpire && tokenIsValid" >
    <form [formGroup]="changePassowrdform" (ngSubmit)="changePassword()"  class="form">
     
  
      <div class="forgot_password" >
        <h2 class="title">Change Password</h2>
        <div class="contain">
          <div class="the_input">
            <label for=""> New Password</label>
            <input type="password" formControlName="password" class="default_input" placeholder="Enter new password" (input)="formInputChange()" [ngClass]="{ 'inactive_input': (gatewayService.isLoading$ | async) }" [readonly]="(gatewayService.isLoading$ | async)"/>
            <div *ngIf="submitted && f.password.errors" >
              <div *ngIf="f.password.errors.required" style="color: red; padding-top: 3px;">Password is required</div>
              <div *ngIf="f.password.errors.minlength" style="color: red; padding-top: 3px;">Password must be at least 6 characters</div>
          </div>
          </div>
  
          <div class="the_input">
            <label for="">Confirm Password</label>
            <input type="password" formControlName="confirmPassword" class="default_input" placeholder="Confirm password" (input)="formInputChange()" [ngClass]="{ 'inactive_input': (gatewayService.isLoading$ | async) }" [readonly]="(gatewayService.isLoading$ | async)"/>
            <div *ngIf="submitted && f.confirmPassword.errors" >
              <div *ngIf="f.confirmPassword.errors.required" style="color: red; padding-top: 3px;">Confirm password is required</div>
              <div *ngIf="f.confirmPassword.errors.mustMatch" style="color: red; padding-top: 3px;">Passwords must match</div>
             </div>
          
          </div>
          
        </div>
    
       

        <div class="sign_in-submit">
          <button type="submit" class="default_primary-button"  [ngClass]="{ 'inactive_btn': (gatewayService.isLoading$ | async) }" [disabled]="(gatewayService.isLoading$ | async)">
            Submit
          </button>
  
          <div *ngIf="(gatewayService.isLoading$ | async)">
            <mat-progress-spinner mode="indeterminate" diameter='30' strokeWidth='1' ></mat-progress-spinner>
          </div>
          
        </div>
      </div>
      </form>
  </div>

 
 
</main>




